import { Component, CUSTOM_ELEMENTS_SCHEMA, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

export type ToastType = 'success' | 'error' | 'warning' | 'info';
export type ToastPosition = 'top-right' | 'top-left' | 'top-center' | 'bottom-right' | 'bottom-left' | 'bottom-center';

@Component({
    selector: 'app-toast-notification',
    templateUrl: './toast-notification.component.html',
    styleUrls: ['./toast-notification.component.scss'],
    imports: [CommonModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ToastNotificationComponent implements OnInit, OnDestroy {
  @Input() visible: boolean = false;
  @Input() type: ToastType = 'info';
  @Input() message: string = '';
  @Input() title: string = '';
  @Input() icon: string = '';
  @Input() duration: number = 5000; // Auto-dismiss after 5 seconds by default
  @Input() autoDismiss: boolean = true;
  @Input() position: ToastPosition = 'top-right';
  @Input() showCloseButton: boolean = true;

  @Output() dismiss = new EventEmitter<void>();

  private timeoutId?: number;

  ngOnInit(): void {
    if (this.autoDismiss && this.visible && this.duration > 0) {
      this.startAutoDismissTimer();
    }
  }

  ngOnDestroy(): void {
    this.clearAutoDismissTimer();
  }

  onDismiss(): void {
    this.clearAutoDismissTimer();
    this.dismiss.emit();
  }

  private startAutoDismissTimer(): void {
    this.timeoutId = window.setTimeout(() => {
      this.onDismiss();
    }, this.duration);
  }

  private clearAutoDismissTimer(): void {
    if (this.timeoutId) {
      window.clearTimeout(this.timeoutId);
      this.timeoutId = undefined;
    }
  }

  get toastIcon(): string {
    if (this.icon) {
      return this.icon;
    }

    // Default icons based on type
    switch (this.type) {
      case 'success':
        return 'check-circle';
      case 'error':
        return 'alert-circle';
      case 'warning':
        return 'alert-triangle';
      case 'info':
      default:
        return 'info';
    }
  }

  get toastIconColor(): string {
    switch (this.type) {
      case 'success':
        return 'success-500';
      case 'error':
        return 'error-500';
      case 'warning':
        return 'warning-500';
      case 'info':
      default:
        return 'info-500';
    }
  }
}
